import { files } from "@/firebase.js";
import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    messagesFrequency: null,
    messagesFrequencyLoading: false,
    devicesFailedHB: null,
    devicesFailedHBLoading: false,
    consumerAvgProcTime: null,
    consumerAvgProcTimeLoading: false,
    eventsToBeProcessed: null,
    eventsToBeProcessedLoading: false
  },
  mutations: {
    setMessagesFrequency(state, payload) {
      state.messagesFrequency = payload;
    },
    setMessagesFrequencyLoading(state, payload) {
      state.messagesFrequencyLoading = payload;
    },
    setDevicesFailedHB(state, payload) {
      state.devicesFailedHB = payload;
    },
    setDevicesFailedHBLoading(state, payload) {
      state.devicesFailedHBLoading = payload;
    },
    setConsumerAvgProcTime(state, payload) {
      state.consumerAvgProcTime = payload;
    },
    setConsumerAvgProcTimeLoading(state, payload) {
      state.consumerAvgProcTimeLoading = payload;
    },
    setEventsToBeProcessed(state, payload) {
      state.eventsToBeProcessed = payload;
    },
    setEventsToBeProcessedLoading(state, payload) {
      state.eventsToBeProcessedLoading = payload;
    }
  },
  actions: {
    async loadMessagesFrequency({ commit }, device_id) {
      commit("setMessagesFrequencyLoading", true);
      let messagesFrequency = await api.get("statistics/messagesFrequency", {
        params: { device_id: device_id }
      });
      commit("setMessagesFrequency", messagesFrequency.data);
      commit("setMessagesFrequencyLoading", false);
    },
    async loadDevicesFailedHB({ commit }) {
      commit("setDevicesFailedHBLoading", true);
      let devicesFailedHB = await api.get("statistics/devicesFailedHeartbeat");
      commit("setDevicesFailedHB", devicesFailedHB.data);
      commit("setDevicesFailedHBLoading", false);
    },
    async loadConsumerAvgProcTime({ commit }) {
      commit("setConsumerAvgProcTimeLoading", true);
      let consumerAvgProcTime = await api.get(
        "statistics/consumerAvgProcessTimeEvents"
      );
      commit("setConsumerAvgProcTime", consumerAvgProcTime.data);
      commit("setConsumerAvgProcTimeLoading", false);
    },
    async loadEventsToBeProcessed({ commit }) {
      commit("setEventsToBeProcessedLoading", true);
      let eventsToBeProcessed = await api.get("statistics/eventsToBeProcessed");
      commit("setEventsToBeProcessed", eventsToBeProcessed.data);
      commit("setEventsToBeProcessedLoading", false);
    }
  },
  getters: {
    messagesFrequency(state) {
      return state.messagesFrequency;
    },
    messagesFrequencyLoading(state) {
      return state.messagesFrequencyLoading;
    },
    devicesFailedHB(state) {
      return state.devicesFailedHB;
    },
    devicesFailedHBLoading(state) {
      return state.devicesFailedHBLoading;
    },
    consumerAvgProcTime(state) {
      return state.consumerAvgProcTime;
    },
    consumerAvgProcTimeLoading(state) {
      return state.consumerAvgProcTimeLoading;
    },
    eventsToBeProcessed(state) {
      return state.eventsToBeProcessed;
    },
    eventsToBeProcessedLoading(state) {
      return state.eventsToBeProcessedLoading;
    }
  }
};
